class NutritionLog {
    breakfast = {
        energy: 0,
        protein: 0,
    };

    lunch = {
        energy: 0,
        protein: 0,
    };

    dinner = {
        energy: 0,
        protein: 0,
    };

    snack = {
        energy: 0,
        protein: 0,
    };

    output = {
        energy: {
            $target: null,
            $logged: null,
            $differenz: null,
            $percentage: null,
        },
        protein: {
            target: {
                $min: null,
                $max: null
            },
            $logged: null,
            $differenz: null,
            $percentage: null,
        },
    };

    total = {
        energy: 0,
        protein: 0,
    };

    difference = {
        energy: 0,
        protein: 0,
    };

    percentage = {
        energy: 0,
        protein: 0,
    };

    stateClasses = {
        sufficent: 'calculation__row--sufficent',
        insufficent: 'calculation__row--insufficent',
    };

    constructor($el, bmrCalculator) {
        this.$el = $el;
        this.bmrCalculator = bmrCalculator;

        // breakfast
        this.$breakfast_energy = $('[name="breakfast_energy"]');
        this.$breakfast_protein = $('[name="breakfast_protein"]');

        // lunch
        this.$lunch_energy = $('[name="lunch_energy"]');
        this.$lunch_protein = $('[name="lunch_protein"]');

        // dinner
        this.$dinner_energy = $('[name="dinner_energy"]');
        this.$dinner_protein = $('[name="dinner_protein"]');

        // snack
        this.$snack_energy = $('[name="snack_energy"]');
        this.$snack_protein = $('[name="snack_protein"]');

        // percentage rows
        this.$energy_row = $('[data-nutrition-log="energy-row"]');
        this.$protein_row = $('[data-nutrition-log="protein-row"]');

        this.$separator = $('[data-nutrition-log="separator"]');


        // output energy
        this.output.energy.$target = $('[data-nutrition-log="energy-target"]');
        this.output.energy.$logged = $('[data-nutrition-log="energy-logged"]');
        this.output.energy.$differenz = $('[data-nutrition-log="energy-differenz"]');
        this.output.energy.$percentage = $('[data-nutrition-log="energy-percentage"]');

        // output protein
        this.output.protein.target.$min = $('[data-nutrition-log="protein-min"]');
        this.output.protein.target.$max = $('[data-nutrition-log="protein-max"]');
        this.output.protein.$logged = $('[data-nutrition-log="protein-logged"]');
        this.output.protein.$differenz = $('[data-nutrition-log="protein-differenz"]');
        this.output.protein.$percentage = $('[data-nutrition-log="protein-percentage"]');

        this.init();
    }

    init = () => {
        this.bmrCalculator.$el.on('energyChanged', this.energyChangeHandler);
        this.bmrCalculator.$el.on('proteinChanged', this.proteinChangeHandler);

        // breakfast
        this.$breakfast_energy.on('change', this.updateLogs);
        this.$breakfast_protein.on('change', this.updateLogs);

        // lunch
        this.$lunch_energy.on('change', this.updateLogs);
        this.$lunch_protein.on('change', this.updateLogs);

        // dinner
        this.$dinner_energy.on('change', this.updateLogs);
        this.$dinner_protein.on('change', this.updateLogs);

        // snack
        this.$snack_energy.on('change', this.updateLogs);
        this.$snack_protein.on('change', this.updateLogs);

        this.updateEnergy();
        this.updateProtein();
        this.updateLogs();
    }

    updateEnergy = () => {
        this.output.energy.$target.text(this.bmrCalculator.energy);

        this.$el.trigger('changed');
    }

    updateProtein = () => {
        this.output.protein.target.$min.text(this.bmrCalculator.protein.min);
        this.output.protein.target.$max.text(this.bmrCalculator.protein.max);

        if (this.bmrCalculator.protein.min != 0 && (this.bmrCalculator.protein.min == this.bmrCalculator.protein.max)) {
            this.$separator.addClass('d-none');
            this.output.protein.target.$max.addClass('d-none');
        } else {
            this.$separator.removeClass('d-none');
            this.output.protein.target.$max.removeClass('d-none');
        }

        this.$el.trigger('changed');
    }

    proteinChangeHandler = () => {
        this.updateProtein();
        this.calculateProtein();
        this.outputLogs();
    }

    energyChangeHandler = () => {
        this.updateEnergy();
        this.calculateEnergy();
        this.outputLogs();
    }

    calculateEnergy = () => {
        this.total.energy = this.breakfast.energy + this.lunch.energy + this.dinner.energy + this.snack.energy;
        this.difference.energy = this.total.energy - this.bmrCalculator.energy;
        this.percentage.energy = Number.parseFloat((this.total.energy / this.bmrCalculator.energy) * 100).toFixed(0);
    }

    calculateProtein = () => {
        this.total.protein = this.breakfast.protein + this.lunch.protein + this.dinner.protein + this.snack.protein;
        this.difference.protein = this.total.protein - this.bmrCalculator.protein.min;
        this.percentage.protein = Number.parseFloat((this.total.protein / this.bmrCalculator.protein.min) * 100).toFixed(0)
    }

    updateLogs = () => {
        // breakfast
        this.breakfast.energy = this.$breakfast_energy.val() ? parseInt(this.$breakfast_energy.val(), 10) : 0;
        this.breakfast.protein = this.$breakfast_protein.val() ? parseInt(this.$breakfast_protein.val(), 10) : 0;

        // lunch
        this.lunch.energy = this.$lunch_energy.val() ? parseInt(this.$lunch_energy.val(), 10) : 0;
        this.lunch.protein = this.$lunch_protein.val() ? parseInt(this.$lunch_protein.val(), 10) : 0;

        // dinner
        this.dinner.energy = this.$dinner_energy.val() ? parseInt(this.$dinner_energy.val(), 10) : 0;
        this.dinner.protein = this.$dinner_protein.val() ? parseInt(this.$dinner_protein.val(), 10) : 0;

        // snack
        this.snack.energy = this.$snack_energy.val() ? parseInt(this.$snack_energy.val(), 10) : 0;
        this.snack.protein = this.$snack_protein.val() ? parseInt(this.$snack_protein.val(), 10) : 0;

        // energy calculations
        this.calculateEnergy();

        // protein calculations
        this.calculateProtein();

        // if (this.total.protein < this.bmrCalculator.protein.min) {
        //     this.difference.protein = this.total.protein - this.bmrCalculator.protein.min;
        //     this.percentage.protein = Number.parseFloat((this.total.protein / this.bmrCalculator.protein.min) * 100).toFixed(0)
        // } else if (this.total.protein > this.bmrCalculator.protein.max)  {
        //     this.difference.protein = this.total.protein - this.bmrCalculator.protein.max;
        //     this.percentage.protein = Number.parseFloat((this.total.protein / this.bmrCalculator.protein.max) * 100).toFixed(0)
        // } else {
        //     this.difference.protein = 0;
        //     this.percentage.protein = 100;
        // }

        this.outputLogs();
    }

    outputLogs = () => {
        // energy
        this.output.energy.$logged.text(this.total.energy);
        this.output.energy.$differenz.text(this.difference.energy > 0 ? `+${this.difference.energy}` : this.difference.energy);
        this.output.energy.$percentage.text(`${this.percentage.energy}%`);

        if (this.percentage.energy >= 100) {
            this.$energy_row.addClass(this.stateClasses.sufficent);
            this.$energy_row.removeClass(this.stateClasses.insufficent);
        } else {
            this.$energy_row.addClass(this.stateClasses.insufficent);
            this.$energy_row.removeClass(this.stateClasses.sufficent);
        }

        // protein
        this.output.protein.$logged.text(this.total.protein);
        this.output.protein.$differenz.text(this.difference.protein > 0 ? `+${this.difference.protein}` : this.difference.protein);
        this.output.protein.$percentage.text(`${this.percentage.protein}%`);

        if (this.percentage.protein < 100) {
            this.$protein_row.addClass(this.stateClasses.insufficent);
            this.$protein_row.removeClass(this.stateClasses.sufficent);
        } else {
            this.$protein_row.addClass(this.stateClasses.sufficent);
            this.$protein_row.removeClass(this.stateClasses.insufficent);
        }

        this.$el.trigger('changed');
    }
}

export default NutritionLog;
